class ScriptLoader {
  constructor() {
    this.events = new Map();
    this.loaded = new Set();
  }

  addEventListener(eventName, callback) {
    if (typeof callback !== "function") return;

    if (this.isLoaded(eventName)) {
      callback.call(null, this);
      return;
    }

    if (!this.events.has(eventName)) {
      this.events.set(eventName, []);
    }

    this.events.get(eventName).push(callback);
  }

  fireEvent(eventName, ...args) {
    this.loaded.add(eventName);

    const callbacks = this.events.get(eventName) || [];
    this.events.set(eventName, []);
    callbacks.forEach((callback) => callback.call(null, this, ...args));
  }

  isLoaded(eventName) {
    return this.loaded.has(eventName);
  }

  load(params = {}) {
    if (!params.src) return false;

    const sources = Array.isArray(params.src) ? [...params.src] : [params.src];
    const eventName = params.name || sources[0];

    if (this.isLoaded(eventName)) {
      if (typeof params.success === "function") params.success();
      return true;
    }

    const loadNext = () => {
      if (sources.length === 0) return;

      const source = sources.shift();
      const script = document.createElement("script");
      script.src = source;
      script.async = true;

      script.onload = () => {
        if (typeof params.success === "function") params.success();
        this.fireEvent(eventName);
      };

      script.onerror = () => {
        if (sources.length > 0) {
          loadNext();
        } else if (typeof params.onTimeout === "function") {
          params.onTimeout(source);
        }
      };

      document.head.appendChild(script);
    };

    loadNext();
    return true;
  }
}

window.scriptLoader = window.scriptLoader || new ScriptLoader();
